<template>
  <div>
    <!-- <group-create-modal>
      <template v-slot:activator="{ on, attrs }">
        <button v-bind="attrs" v-on="on" @click="createGroup">
          <group-row-avatar label="Create New Group" icon="mdi-plus">
          </group-row-avatar>
        </button>
      </template>
    </group-create-modal> -->
    <v-btn
      v-if="!$vuetify.breakpoint.xsOnly"
      color="primary"
      @click="createGroup"
      class="newGroup"
    >
      + New Group
      <!-- <group-row-avatar label="Create Group" icon="mdi-plus"></group-row-avatar> -->
    </v-btn>
    <div v-else class="newGroup">
      <span @click="createGroup"> + New Group </span>
    </div>
  </div>
</template>

<script>
// import GroupCreateModal from "./GroupCreateModal.vue";
// import GroupRowAvatar from "./GroupRowAvatar.vue";
import { mapActions } from "vuex";
export default {
  props: ["profile_object"],
  components: {
    // GroupCreateModal,
    // GroupRowAvatar,
  },
  methods: {
    ...mapActions({
      toggleGroupModal: "group/toggleShowGroupModal",
    }),
    createGroup() {
      this.$logEvent("add_new_group_button");
      if (this.$vuetify.breakpoint.xsOnly) {
        this.$logEvent("mweb_add_new_group_button");
      }
      console.log("clicked on add group");
      this.toggleGroupModal({
        show: true,
        type: "add",
        profile_object: this.profile_object,
      });
    },
  },
};
</script>
<style scoped>
@media only screen and (max-width: 768px) {
  .newGroup {
    font-family: Avenir;
    font-size: 14px;
    font-weight: 800;
    line-height: 19.12px;
    text-align: right !important;
    color: #2d8cff;
  }
}
.newGroup {
  text-transform: capitalize;
  font-family: Avenir;
  font-size: 15px;
  font-weight: 500;
  line-height: 20.49px;
  text-align: center;

  width: 163px;
  height: 42px !important;
  border-radius: 6px;
}
</style>
